<template>
  <div
    :id="modalId"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="noteModalLabel"
    aria-hidden="true"
    @click.self="hide"
    @keydown.esc.window="hide"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="noteModalLabel" style="display: inline">
            {{ isEdit ? 'Edit Note' : 'New Note' }}
          </h5>
          <button type="button" class="close" @click="hide">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="noteTextarea" class="form-control-label"
              ><span>Add note below</span>
              <span class="form-control-label__container-select"
                >Type
                <multiselect
                  :value="options.find((o) => o.id === localType) || null"
                  @input="(option) => (localType = option ? option.id : null)"
                  :options="options"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  :tabindex="2"
                  :multiple="false"
                >
                </multiselect
                ><a
                  href=""
                  @click.prevent="onEstimateNote"
                  v-b-tooltip.hover="{
                    customClass: 'ps-tooltip',
                    title: 'Add this note to the Estimate',
                    placement: 'left',
                  }"
                  ><i
                    class="bx bxs-file-plus"
                    style="color: #000000; font-size: x-large"
                  ></i
                ></a>
              </span>
            </label>
            <textarea
              v-model="localNote"
              class="form-control"
              id="noteTextarea"
              rows="10"
              style="height: auto"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary mr-1" @click="save">
            <i class="ti-save"></i> Save Note
          </button>
          <button type="button" class="btn btn-secondary" @click="hide">
            <i class="ti-close"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'NoteModal',
  components: {
    Multiselect,
  },
  props: {
    noteId: {
      type: [String, Number],
      default: null,
    },
    note: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'General',
    },
    modalId: {
      type: String,
      default: 'noteBoxModal',
    },
  },
  data() {
    return {
      localNote: this.note,
      localType: this.type,
      options: [
        { id: 'General', name: 'General' },
        { id: 'AccidentDetails', name: 'Accident Details' },
        { id: 'Authority', name: 'Authority' },
        { id: 'Customer', name: 'Customer' },
        { id: 'EstimateNote', name: 'Estimate Note (Added)' },
        { id: 'SubletInvoice', name: 'Sublet Invoice' },
        { id: 'SupplierInvoice', name: 'Supplier Invoice' },
        { id: 'SupplierCredit', name: 'Supplier Credit' },
        { id: 'Mechanical', name: 'Mechanical' },
        { id: 'VehicleIdentification', name: 'Vehicle Identification' }
      ],
    };
  },
  computed: {
    isEdit() {
      return this.noteId !== null && this.noteId !== undefined;
    },
  },
  watch: {
    noteId(newVal) {
      console.log('noteId', newVal);
    },
    note: {
      handler(newVal) {
        console.log('note', newVal);
        this.localNote = newVal;
      },
    },
    type: {
      handler(newVal) {
        console.log('type', newVal);
        this.localType = newVal;
      },
    },
  },
  methods: {
    show() {
      this.$nextTick(() => {
        $(`#${this.modalId}`).modal({
          show: true,
          backdrop: true,
          keyboard: true,
        });
      });
    },
    hide() {
      $(`#${this.modalId}`).modal('hide');
      // (this.localNote = ''), (this.localType = 'General');
      // this.$emit('update:noteId', null);
      // console.log('id', this.noteId);
    },
    save() {
      const note = {
        id: this.noteId,
        note: this.localNote,
        type: this.localType,
      };
      this.$emit('save', note);
      if (!this.noteId) {
        (this.localNote = ''), (this.localType = 'General');
      }
      this.hide();
    },
    onEstimateNote() {
      this.localType = 'EstimateNote';
    },
  },
};
</script>

<style scoped>
.form-control-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 700;
}
.form-control-label__container-select {
  display: flex;
  width: 50%;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-left: auto;
}
</style>
